import { DictionaryAutocomplete } from '@eas/common-web';
import { IpEntry } from '@models';
import * as Yup from 'yup';

export function useValidationSchema() {
  return Yup.object<IpEntry>().shape({
    ip: Yup.string().nullable().required(),
    mode: Yup.mixed<DictionaryAutocomplete>().nullable().required(),
  }) as Yup.Schema<IpEntry>;
}
